export default [
    'box-shadow: -1px -1px 2px rgb(255,255,255, 0.0), 1px 1px 2px  rgb(94,138,253, 0.0);',
    'box-shadow: -1px -1px 2px rgb(119,188,239, 0.5), 1px 1px 2px  rgb(33, 63, 232, 0.3);',
    'box-shadow: -2px -2px 4px rgb(119,188,239, 0.5), 2px 2px 4px  rgb(33, 63, 232, 0.3);',
    'box-shadow: -4px -4px 6px rgb(119,188,239, 0.5), 4px 4px 6px  rgb(33, 63, 232, 0.3);',
    'box-shadow: -6px -6px 8px rgb(119,188,239, 0.5), 6px 6px 8px  rgb(33, 63, 232, 0.3);',
    'box-shadow: -8px -8px 10px rgb(119,188,239, 0.5), 8px 8px 10px  rgb(33, 63, 232, 0.3);',
    'box-shadow: 4px 4px 4px #CFDBE8, 8px 8px 8px #CFDBE8, -4px -4px 4px #EDF2F8, -8px -8px 15px #EDF2F8;',
    'box-shadow: 7px 7px 15px rgba(55, 84, 170, .15), -7px -7px 20px rgba(255, 255, 255, 1), 0px 0px 4px rgba(255, 255, 255, .2) !important;'
];


